import { Icon, InputAdornment } from "@mui/material";
import MDBox from "components/MDBox";
import UiInput from "components/base/UiInput";
import { draftColors } from "modules/proposals/draft/draftDesignTokens";

type PickerSearchProps = {
  value: string | null;
  placeholder: string;
  onChange: (value: string) => void;
};

export default function PickerSearch({ value, placeholder, onChange }: PickerSearchProps) {
  return (
    <MDBox pt="8px" pb="10px">
      <UiInput
        fullWidth
        value={value ?? ""}
        placeholder={placeholder}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Icon sx={{ fontSize: 16, color: draftColors.textSecondary }}>search</Icon>
            </InputAdornment>
          ),
        }}
        sx={{
          "& .MuiInputBase-root": {
            height: "34px",
            borderRadius: "8px",
            backgroundColor: draftColors.surfaceMuted,
          },
          "& .MuiInputBase-input": { pl: "4px" },
          "& .MuiInputAdornment-root": { ml: "8px", mr: 0 },
        }}
        onChange={(event) => onChange(event.target.value)}
      />
    </MDBox>
  );
}
